import React, { useMemo } from 'react';
import { clsx } from "clsx";
import { formatDate, IconName } from "../../utils";
import IconSvg from "../IconSvg/IconSvg";
import { isEmpty } from "lodash";
import { ORDER_STATUS } from "../../constants";

const OrderTracker = ({ orderDetail }) => {
  const getStepTime = (status) => {
    if (!orderDetail?.statusChanges?.length) return ""
    const statusChange = orderDetail?.statusChanges.find((change) => change?.status === status)
    return statusChange ? formatDate(statusChange?.createdAt) : ""
  }

  const steps = [
    {
      id: 1,
      title: 'Chờ xác nhận',
      time: getStepTime(ORDER_STATUS.ORDER_CREATED),
      icon: IconName.documents
    },
    /*
    {
      id: 2,
      title: 'Giao nhà vận chuyển',
      time: getStepTime("seller_confirm"),
      icon: IconName.documentCheck
    },
    */
    {
      id: 2,
      title: orderDetail?.status === ORDER_STATUS.ORDER_CANCEL ? 'Đơn hàng đã hủy' : 'Đang vận chuyển',
      time: orderDetail?.status === ORDER_STATUS.ORDER_CANCEL ? getStepTime(ORDER_STATUS.ORDER_CANCEL) : getStepTime(ORDER_STATUS.SHIPPING_PROCESSING),
      icon: orderDetail?.status === ORDER_STATUS.ORDER_CANCEL ? IconName.canceled : IconName.delivery
    },
    {
      id: 3,
      title: 'Giao hàng thành công',
      time: getStepTime(ORDER_STATUS.SHIPPING_DONE),
      icon: IconName.check
    }
  ];
  const currentStep = useMemo(() => {
    /* 4-step logic
    if (isEmpty(orderDetail)) return 2
    if (orderDetail?.status === 'shipping_processing' || orderDetail?.status === 'order_cancel') return 3
    if (orderDetail?.status === 'shipping_done') return 4
    return 2
    */

    if (isEmpty(orderDetail)) return 1
    if (orderDetail?.status === ORDER_STATUS.SHIPPING_PROCESSING || orderDetail?.status === ORDER_STATUS.ORDER_CANCEL) return 2
    if (orderDetail?.status === ORDER_STATUS.SHIPPING_DONE) return 3
    return 1
  }, [orderDetail])

  return (
    <div className="hidden md:block w-full py-6 bg-white">
      <div className="relative flex justify-between">
        <div className={clsx("absolute top-5 h-[4px] flex z-0",
          steps.length === 3 ? "left-[16.6%] right-[16.6%]" : "left-[11%] right-[11%]"
        )}>
          {steps.map((_, index) => {
            if (index === steps.length - 1) return null;
            const lineStatus =
              index + 1 < currentStep ? 'completed' :
                index + 1 === currentStep ? 'current' : 'upcoming';
            return (
              <div key={index} className="flex-1 flex items-center">
                <div className={clsx('h-[4px] w-full',
                  lineStatus === 'completed' ? 'bg-[#197D55]' : 'bg-[#D1E5DD]'
                )}>

                </div>
              </div>
            );
          })}
        </div>
        {steps.map((step, index) => (
          <div key={step.id} className="relative flex flex-col items-center flex-1 z-2">
            <div
              className={clsx('w-10 h-10 rounded-full flex items-center justify-center border-2',
                index < currentStep - 1 ? 'bg-[#197D55] text-white' : 'bg-white  text-gray-400',
                index <= currentStep - 1 ? 'border-[#197D55]' : 'border-[#D1E5DD]'
              )}>
              <IconSvg
                iconName={step.icon}
                color={index < currentStep - 1 ? 'white' : index === currentStep - 1 ? '#197D55' : '#D1E5DD'}
                size={24}
              />
            </div>
            <div className="mt-3 flex flex-col items-center text-center">
              <div
                className={clsx('text-sm font-medium', step.id <= currentStep ? 'text-black' : 'text-gray-400')}>{step.title}</div>
              {step.time && (
                <div className="text-xs text-gray-500 mt-1">
                  {step.time}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderTracker;
